<script>
import moment from "@/utils/moment";
import orderMixin from "@/mixins/orderMixin";

import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";

export default {
  mixins: [orderMixin],

  components: {
    Header,
    Body,
    Footer
  },

  props: {
    payable: {
      type: Object,
      required: true
    }
  },

  methods: {
    redirect() {
      if (this.noValidPayment) {
        return this.$router.push({
          name: "order-checkout",
          params: { order_id: this.payable.id }
        });
      }

      this.$router.push({
        name: "order",
        params: { order_id: this.payable.id }
      });
    }
  },

  computed: {
    inTimeToPay: function() {
      return this.haveTimeToPay(this.payable.created_at);
    },

    noValidPayment: function() {
      return this.inTimeToPay && !this.validPayment;
    },

    validPayment: function() {
      return (
        this.hasAPendingBoleto(this.payable.payments) ||
        !this.isOrderPayable(this.payable)
      );
    },

    paid: function() {
      return this.payable.status === "paid";
    },

    provisioning: function() {
      return this.payable.status === "provisioning";
    }
  }
};
</script>

<template>
  <div
    class="order-card"
    :class="{
      'order-card-schedule': noValidPayment,
      'order-card-waiting': validPayment,
      'order-card-paid': paid,
      'order-card-provisioning': provisioning
    }"
    @click="redirect"
  >
    <Header :order="this.payable" />

    <Body :order="this.payable" />

    <Footer :noValidPayment="noValidPayment" />
  </div>
</template>

<style scoped>
.order-card {
  width: calc(100% - 24px - 2px);
  padding: 12px;
  position: relative;
  background-color: #fff;
  border: solid 1px #e2e2e2;
  border-radius: 2px;
  cursor: pointer;
  user-select: none;
}

.order-card::before {
  width: calc(100% + 2px);
  height: 6px;
  position: absolute;
  top: -1px;
  left: -1px;
  content: "";
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
}

.order-card-schedule::before {
  background-color: #2196f3;
}

.order-card-waiting::before {
  background-color: #ffc107;
}

.order-card-paid::before {
  background-color: #4caf50;
}

.order-card-provisioning::before {
  background-color: #603285;
}

.order-card:not(:last-child) {
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/Components/Card/Index.vue